<template>
  <div class="grid myhome-events">
    <SidebarEvents v-if="['events'].indexOf($route.name) > -1 && registrationsLoaded">
      <SidebarLinkList :items="myHomeLinks"></SidebarLinkList>
    </SidebarEvents>
    <Sidebar v-else-if="['registration'].indexOf($route.name) > -1 && registrationIsLoaded">
      <Registrations :registrations="[activeRegistration()]"></Registrations>
    </Sidebar>
    <Sidebar v-else-if="['registration'].indexOf($route.name) === -1 && registrationsLoaded">
      <Registrations :registrations="[activeRegistration()]"></Registrations>
    </Sidebar>
    <router-view v-if="registrationsLoaded"></router-view>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import SidebarLinkList from "@/components/elements/SidebarLinkList";
import Loader from "@/components/elements/Loader";
import SidebarEvents from "~/components/events/components/SidebarEvents";
import Sidebar from "~/components/events/components/Sidebar";
import Registrations from "~/components/events/components/Registrations";

export default {
  name: "EventsMain",
  components: {
    SidebarEvents,
    Registrations,
    Sidebar,
    SidebarLinkList,
    Loader,
  },
  computed: {
    ...mapGetters([
      "user",
      "config",
      "ticketFilter",
      "titles",
      "activeRegistration",
      "registrationsLoaded",
      "registrationIsLoaded",
      "filteredRegistrations",
    ]),
    myHomeLinks() {
      return [
        {
          name: this.titles.sidebar.future,
          active: this.ticketFilter === "future",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "future",
        },
        {
          name: this.titles.sidebar.festival,
          active: this.ticketFilter === "festival",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "festival",
        },
        {
          name: this.titles.sidebar.past,
          active: this.ticketFilter === "past",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "past",
        },
        {
          name: this.titles.sidebar.waitingList,
          active: this.ticketFilter === "waitingList",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "waitingList",
        },
        {
          name: this.titles.sidebar.ordersRecap,
          active: this.ticketFilter === "ordersRecap",
          colorMod: "dea-border-target-magenta-formazione",
          action: this.changeView,
          status: "ordersRecap",
        },
      ];
    },
  },
  created() {
    if (!this.registrationsLoaded) this.fetchRegistrations(this.$route.params.registration);
  },
  methods: {
    ...mapMutations(["setTicketFilter"]),
    ...mapActions(["fetchRegistrations"]),
    changeView(status) {
      this.setTicketFilter(status.status);
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$route.params.ticketFilter) {
        vm.setTicketFilter(vm.$route.params.ticketFilter);
      } else {
        const mainTab = vm.myHomeLinks[0];
        for (let i = 0; i < vm.myHomeLinks.length; i += 1) {
          const el = vm.myHomeLinks[i];
          vm.setTicketFilter(el.status);
          if (vm.filteredRegistrations().length) return;
          if (i === vm.myHomeLinks.length - 1) vm.setTicketFilter(mainTab.status);
        }
      }
    });
  },
};
</script>
